import React, { useState } from "react";
import { Box, Divider } from "@mui/material";

import Body from "./Body";
import Footer from "./Footer";
import Header from "./Header";

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmNewPassword: "",
  });
  const [currentStep, setCurrentStep] = useState("");
  const [passwordError, setPasswordError] = useState({
    newPassword: false,
    confirmNewPassword: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    setFormData((prev) => ({ ...prev, [name]: value }));
  
    if (name === "newPassword") {
      if (value.length < 8) {
        setPasswordError((prev) => ({
          ...prev,
          newPassword: "Password must be at least 8 characters",
        }));
      } else {
        setPasswordError((prev) => ({
          ...prev,
          newPassword: "",
        }));
      }
  
      // Re-validate confirm password if it's already filled
      if (formData.confirmNewPassword) {
        if (formData.confirmNewPassword !== value) {
          setPasswordError((prev) => ({
            ...prev,
            confirmNewPassword: "Passwords do not match",
          }));
        } else {
          setPasswordError((prev) => ({
            ...prev,
            confirmNewPassword: "",
          }));
        }
      }
    }
  
    if (name === "confirmNewPassword") {
      if (value.length < 8) {
        setPasswordError((prev) => ({
          ...prev,
          confirmNewPassword: "Password must be at least 8 characters",
        }));
      } else if (value !== formData.newPassword) {
        setPasswordError((prev) => ({
          ...prev,
          confirmNewPassword: "Passwords do not match",
        }));
      } else {
        setPasswordError((prev) => ({
          ...prev,
          confirmNewPassword: "",
        }));
      }
    }
  };  

  return (
    <Box sx={{ width: "76%" }}>
      <Header />
      <Divider />
      <Body
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        formData={formData}
        handleChange={handleChange}
        passwordError={passwordError}
      />
      <Divider />
      <Footer
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        formData={formData}
      />
    </Box>
  );
};

export default ChangePassword;
